var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RtVideoPlayer"},[_c('div',{style:({ paddingTop: (((1 / _vm.aspectRatio) * 100) + "%") })}),_c('div',{ref:"host",staticClass:"viewport"})])}
var staticRenderFns = []

export { render, staticRenderFns }